export default "__VITE_ASSET__0d954647__"